import React, { ReactElement, useContext } from 'react'

import Fieldset from '../../Common/Components/Fieldset'
import Heading from '../../Common/Components/Heading'
import FormRow from '../../Common/Components/FormRow'
import Checkbox from '../../Common/Components/Checkbox'

import { LanguageContext } from '../../Common/Contexts'

import CLanguageHandler from '../../../NonReact/Languages/LanguageHandler'
import { Advanced as AdvancedLanguage } from '../../../../i18n'
import { HeadingLevel } from '../../Common/Components/Heading/Heading'
import { HelpTagTitles, Tags } from '../../Common/API/Contentful/Constants'
import { HelpTag } from '../../Common/Components/HelpTag/HelpTag'

/**
 * Component properties type.
 */
type Props = {
    autoCalcDuration: boolean
    setAutoCalcDuration: (checked: boolean) => void
    bundleEmailAttachAsZip: boolean
    setBundleEmailAttachAsZip: (checked: boolean) => void
    runWithSimilarSchedules: boolean
    setRunWithSimilarSchedules: (checked: boolean) => void
}

/**
 * Advanced section of scheduling tab in report configuration window.
 *
 * @param autoCalcDuration Report property.
 * @param setAutoCalcDuration Setter for corresponding report property.
 * @param bundleEmailAttachAsZip Report property.
 * @param setBundleEmailAttachAsZip Setter for corresponding report property.
 * @param runWithSimilarSchedules Report property.
 * @param setRunWithSimilarSchedules Setter for corresponding report property.
 */
const Advanced: React.FC<Props> = ({
    autoCalcDuration,
    setAutoCalcDuration,
    bundleEmailAttachAsZip,
    setBundleEmailAttachAsZip,
    runWithSimilarSchedules,
    setRunWithSimilarSchedules
}: Props): ReactElement => {
    const language = useContext(LanguageContext) as CLanguageHandler
    language.loadBundle('Advanced')

    return (
        <Fieldset>
            <Heading level={HeadingLevel.ONE}>
                {language.get(AdvancedLanguage.Advanced_SectionHeader)}
                <HelpTag
                    className='configure-report-help-title-tag'
                    helpContentTitle={HelpTagTitles.CONFIGURE_REPORT_SCHEDULING_ADVANCED}
                    tag={Tags.CONFIGURE_REPORT}
                />
            </Heading>
            <FormRow isInline className={'auto-calculate-duration'}>
                <Checkbox
                    onChange={setAutoCalcDuration}
                    isChecked={autoCalcDuration}
                    labelLeft={language.get(AdvancedLanguage.AutocalcdurationLabel)}
                />
            </FormRow>
            <FormRow isInline className={'bundle-email-in-zip'}>
                <Checkbox
                    onChange={setBundleEmailAttachAsZip}
                    isChecked={bundleEmailAttachAsZip}
                    labelLeft={language.get(AdvancedLanguage.BundleallemailattachinzipLabel)}
                />
            </FormRow>
            <FormRow isInline className={'collate-with-similar'}>
                <Checkbox
                    onChange={setRunWithSimilarSchedules}
                    isChecked={runWithSimilarSchedules}
                    labelLeft={language.get(AdvancedLanguage.RunandcollatewithsimilarschedLabel)}
                />
            </FormRow>
        </Fieldset>
    )
}

export default Advanced
